export default {
  GET_LIST: '/nzjxcApi/Store/GetList',
  APPROVE: '/nzjxcApi/Store/Approve',
  GET_DETAIL: '/nzjxcAPI/Store/Get'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/store/index.js